import { TpSlTriggerPercentBasis } from 'src/components/TradeForm/TpSlOrderForm/types';

export const DEFAULT_TP_SL_TRIGGER_PERCENT_BASIS: TpSlTriggerPercentBasis =
	'price';
